import type {ReactElement} from 'react';
import React from 'react';
import type {ProgressDotsProps} from './progress-dots.types';
import styles from './progress-dots.module.scss';

export function ProgressDots({currentStep, numDots, containerClassName = '', dotClassName = ''}: ProgressDotsProps): ReactElement<any> {
  const isDotActive = (index: number): boolean => {
    return currentStep - 1 >= index;
  };
  return (
    <div className={`flex-row-align-center ${containerClassName}`}>
      {Array.from({length: numDots}, (_, index) => {
        return <div key={`dot-${index}-${numDots}`} className={`${styles.dot} radius-round ${isDotActive(index) ? styles.active : ''} ${dotClassName}`} />;
      })}
    </div>
  );
}
